const getCustomerDetails = (details)=>{
    if (!details) {
        return undefined;
    }
    const { email , phone  } = details;
    var _dateOfBirth;
    return {
        email,
        dateOfBirth: (_dateOfBirth = details.dateOfBirth) !== null && _dateOfBirth !== void 0 ? _dateOfBirth : '',
        phone: phone !== null && phone !== void 0 ? phone : ''
    };
};

export { getCustomerDetails };
//# sourceMappingURL=get-customer-details.js.map
